export const P00076VanneInstallationTypeEnum = [
  { ref: 0, label: 'P00076.vanneinstallationtype.0' },
  { ref: 1, label: 'P00076.vanneinstallationtype.1' },
];
